import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { Form, Input, Select, Button, message, Spin } from "antd";
import BackRouteButton from "src/common/components/BackRouteButton";

const { Option } = Select;

export default ({ createCounteragent, profile }) => {
  const [loading, setLoading] = useState(false);

  const [form] = Form.useForm();
  const history = useHistory();

  const onFinish = async (values) => {
    setLoading(true);

    values.creatorId = profile._id;
    const result = await createCounteragent(values);
    if (result.success) {
      form.resetFields();
      message.success("Counteragent successfully added!");
      history.goBack();
    } else {
      message.error(result.message || "Failed to create counteragent!");
      setLoading(false);
    }
  };

  return (
    <div className="common-container">
      <Spin spinning={loading}>
        <BackRouteButton />
        <h4 className="common-title--large">Add Counteragent</h4>

        <Form
          requiredMark={false}
          layout="vertical"
          form={form}
          onFinish={onFinish}
        >
          <Form.Item
            label="First Name"
            name="firstname"
            rules={[
              {
                required: true,
                message: "Please enter the first name!",
              },
            ]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Last Name"
            name="lastname"
            rules={[
              {
                required: true,
                message: "Please enter the last name!",
              },
            ]}
          >
            <Input />
          </Form.Item>

          <Form.Item label="Middle Name" name="additionalName">
            <Input />
          </Form.Item>

          <Form.Item
            label="Phone"
            name="phone"
            rules={[
              {
                required: true,
                message: "Please enter the phone number!",
              },
            ]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Email"
            name="email"
            rules={[
              {
                type: "email",
                message: "Invalid email format!",
              },
            ]}
          >
            <Input />
          </Form.Item>

          <Form.Item label="Company" name="firm">
            <Input />
          </Form.Item>

          <Form.Item label="Address" name="address">
            <Input />
          </Form.Item>

          <Form.Item label="Comment" name="comment">
            <Input.TextArea />
          </Form.Item>

          <Form.Item
            label="Type"
            name="type"
            rules={[
              {
                required: true,
                message: "Please select the type of counteragent!",
              },
            ]}
          >
            <Select placeholder="Select counteragent type">
              <Option value="buyer">Buyer</Option>
              <Option value="supplier">Supplier</Option>
              <Option value="employee">Employee</Option>
              <Option value="workshop worker">Workshop Worker</Option>
            </Select>
          </Form.Item>

          <Form.Item label="Profession" name="profession">
            <Input />
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit">
              Add
            </Button>
          </Form.Item>
        </Form>
      </Spin>
    </div>
  );
};
